import { Component, Input } from '@angular/core';
import { DataGridComponent } from 'src/app/core/data-grid.component';
import { State } from '@progress/kendo-data-query';
import { tap } from 'rxjs/operators';
import { Connection } from '../models/connection';
import { TopicDataService } from '../services/topic-data.service';

@Component({
  selector: 'app-topics',
  templateUrl: './topics.component.html',
  styleUrls: ['./topics.component.scss']
})
export class TopicsComponent extends DataGridComponent {

  public gridState: State = {
    sort: [
      {
        field: "Name",
        dir: "asc",
      },
    ],
    skip: 0,
    take: 10,
  };
    
  constructor(
    private dataService: TopicDataService
  ) {
    super();
  }

  @Input() public connection: Connection;

  ngOnInit() {
    super.ngOnInit();
  }

  protected refresh() {
    this.view = this.dataService
      .get(this.gridState, `&$filter=connectionId eq ${this.connection.Id}`)
      .pipe(tap(() => (this.loading = false)));
  }

}
